// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1hq8_","productName":"Table_productName__2fHlO"};